import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-reports-nb-transactions-card',
  templateUrl: './payments-reports-nb-transactions-card.component.html',
  styleUrls: ['./payments-reports-nb-transactions-card.component.scss']
})
export class PaymentsReportsNbTransactionsCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
